module.exports = __webpack_public_path__ + "slide-03.png?9c690493e2c7efc6164db2ecae0e2023";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide-03.png
// module id = 390
// module chunks = 0